module.exports = __webpack_public_path__ + "static/media/gold_offer_fisdom3.f036a6f9.jpg";